<template>
  <div class="">
    <div class="custom-loader-wrapper" v-if="loader">
      <div class="text-center">
				<span class="d-block max-450">
					We are processing your download and this may take some time. Do not close this window until the download begins.
				</span>
        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
        <p class="mt-5">
          Plesae click
          <a target="_blank" :href="$api_url+'/'">here</a>
          or below if you want to continue surfing the system.
        </p>
        <b-button class="mb-1" target="_blank" :href="$api_url+'/'">
          Dashboard
        </b-button>
      </div>
    </div>

    <div class="row no-gutters py-2 mb-3 ml-3">
      <div class="col-sm-6 pr-3 ">
        <h4 class="atlhr-dashboard-title mt-10">
          <span class="blue-title">PF</span> Schedule
          <span>
						<a v-bind:href="pageurl">Dashboard</a>
						/ PF Schedule
					</span>
        </h4>
      </div>
    </div>

    <div class="row col-12 no-margin">
      <div class="ibox col-md-12">
        <div class="ibox-title dashboard_title">
          <h4 class="clearfix">
            <span class="float-left">PF Overview</span>
            <span class="float-right">
                            
                        </span>
          </h4>


        </div>
        <div class="ibox-content pf-overview">
          <template v-if="employee_info.length == 0">
            <div class="no-result-cell text-center">
              <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo pf-overview-loader"/>
            </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>Joining Date</h3></div>
                  <div class="col-lg-6 col-md-6 col-sm-12"><span>{{ employee_info.joining_date }}</span></div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>PF Enrollment Date</h3></div>
                  <div class="col-lg-6 col-md-6 col-sm-12"><span>{{ employee_info.PF_enrollment_date }}</span></div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>PF Membership Period</h3></div>
                  <div class="col-lg-6 col-md-6 col-sm-12"><span>{{ employee_info.PF_membership_period }}</span></div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>Service Period</h3></div>
                  <div class="col-lg-6 col-md-6 col-sm-12"><span>{{ employee_info.service_period }}</span></div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>Opening Balance of Fund</h3></div>
                  <template v-if="details.opening_balance != undefined">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <span>{{ formatMoney(employee_info.opening_balance) }}</span></div>
                  </template>

                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12"><h3>Closing Balance of Fund</h3></div>
                  <template v-if="employee_info.closing_balance_of_fund != undefined">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <span>{{ formatMoney(employee_info.closing_balance_of_fund) }}</span></div>
                  </template>

                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
      <div class="ibox col-md-12 border-0">
        <div class="ibox-title dashboard_title company-form-box-title">
          <h4 class="clearfix">
            <span class="float-left">Employees Provident Fund Scheme<span class="title-sub-text">A comprehensive overview of an employee's contributions and balance in their provident fund account.</span></span>
            <span class="float-right">
                            <select id="year" v-model="year" name="year" class="form-control custom-select">
                                <template v-if="pf_settings.pf_year_end.opt_value != 12">
                                    <option v-for='pyr in payrunyears' :value='pyr'>{{ pyr }}</option>
                                </template>	
                                <template v-else>
                                    <option v-for='pyr in f_y' :value='pyr'>{{ pyr }}</option>
                                </template>
                            </select> 
                        </span>

          </h4>
          <h4 class="clearfix">
            <span class="float-left"></span>
            <span class="float-right">
                            <b-button class="mt-3" @click="getEmployeePfReport()">
                                Download Report
                            </b-button>
              <!-- <b-button class="mt-3" @click="showStatementDownloadForm()">
                  Download PF Statement (range)
              </b-button> -->
                            <b-button class="mt-3" @click="showInterestWaiverForm()" v-if="$site_options && $site_options['pf_profit_waive_feature'] == 1"> <!-- Rejwan: 23-06-2026 -->
                                Interest Waiver
                            </b-button>
                        </span>
          </h4>
        </div>
        <div class="ibox-content">
          <b-overlay rounded="sm">


            <template>
              <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">
                                <span class="d-block text-center">
                                    {{ empty_result }}
                                </span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
              </div>
              <div v-else class="overflow-auto">
                <table class="table ">
                  <thead class="" style="">
                  <tr class="table-head" v-for="(detail, index) in details.data" :key="detail.employee_id">
                    <template v-if="index < 1">
                      <template v-for="(v,i,count) in detail">
                        <td class="text-center"
                            v-if="i == 'contribution_year' || i== 'contribution_month' || i== 'type' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) "><!-- Mustafijur: 24-08-2026 -->
                          <template>
                            {{ replaceTableHeads(i) }}
                          </template>
                        </td>
                        <td class="text-center"
                            v-else-if="i == 'monthly_salary' || i== 'employee_contribution' || i== 'company_contribution' || i== 'settlement' || i== 'forfeiture' || i== 'closing_balance'  "><!-- Mustafijur: 24-08-2026 -->
                          <template>
                            {{ replaceTableHeads(i) }}
                          </template>
                        </td>
                        <td class="text-center pf_slip_head" v-else-if="i == 'pf_slip' "><!-- Mustafijur: 24-08-2026 -->
                          <template>
                            PF Slips
                          </template>
                        </td>
                      </template>

                    </template>
                  </tr>
                  </thead>
                  <tbody class="pf-contribution-table-body">
                  <tr style="display: none;">
                  </tr>
                  <tr class="table-row hover-bg " v-for="detail in details.data" :key="detail.employee_id">
                    <!--aboni 10-11-21-->

                    <template v-if="filterFiscalYear(detail.contribution_year,detail.contribution_month)">
                      <template v-for="(v,i,count) in detail">
                        <td class="2"
                            v-if="i == 'contribution_year' || i== 'contribution_month' || i== 'type' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) ">
                          {{ v }}
                        </td>
                        <td class="2 text-right"
                            v-else-if="i == 'monthly_salary' || i== 'employee_contribution' || i== 'company_contribution' || i== 'settlement' || i== 'forfeiture' || i== 'closing_balance'  ">
                          <div v-if="v==0" class="text-center"> <!-- Mustafijur: 23-08-2026 -->
                            --
                          </div>
                          <div v-else>
                            {{ formatMoney(v) }}
                          </div>
                        </td>

                        <td class="2 text-center px-0" style="width: 140px;" v-else-if="i == 'pf_slip' ">
                          <div v-if="v==0" class="text-center"> <!-- Mustafijur: 23-08-2026 -->
                            --
                          </div>
                          <div v-else>
                            <b-button class="my-2 trz_pf_slip_button" @click="showPFSlipModal(detail)">
                              View PF Slip
                            </b-button>
                          </div>
                        </td>
                      </template>
                    </template>


                    <!--aboni 10-11-21-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>

          </b-overlay>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-process-waiver" size="md" hide-footer title="Interest Waiver Form">
      <!-- <pf-interest-waiver-form :employee_info="employee_info" :key="waiver_key" :pageurl="pageurl"
                               :store_scope="store_scope" v-on:childToParent="waiverReturn"></pf-interest-waiver-form> -->
      <pf-interest-waiver-form-front :employee_info="employee_info" :key="waiver_key" :pageurl="$api_url" :store_scope="store_scope" v-on:childToParent="waiverReturn"></pf-interest-waiver-form-front> 
    </b-modal>


    <b-modal id="bv-modal-process-statement" size="md" hide-footer title="Download PF Statement">
      <!-- <pf-statement-download-form :employee_info="employee_info" :key="waiver_key" :pageurl="pageurl"
                                  :store_scope="store_scope"></pf-statement-download-form> -->
      <pf-statement-download-form-front :employee_info="employee_info" :key="waiver_key" :pageurl="$api_url" :store_scope="store_scope"></pf-statement-download-form-front>
    </b-modal>


    <b-modal id="bv-modal-pf-slip" size="lg" hide-footer title="PF Slip">
      <EmployeepfslipdetailsFront :pageurl="pageurl" :payslip="pay_slip_details.payslip_id"
                                  :company="employee_info.company_name" :pmonth="pay_slip_details.contribution_month"
                                  :pyear="pay_slip_details.contribution_year" :dynamic_fields="dynamic_fields"
                                  :year_end="pf_settings.pf_year_end.opt_value"
                                  :payslipname="'PF Slip for '+employee_info.employee_name+' - '+pay_slip_details.contribution_month+' '+pay_slip_details.contribution_year"></EmployeepfslipdetailsFront>
    </b-modal>

    <!-- <Employeepfslipdetails :pageurl="pgurl" :payslip="payslip.id" :company="companies[payslip.company_id]"  :pmonth="payslip.month" :pyear="payslip.year" :dynamic_fields="dynamic_fields" :payslipname="'PF Slip for '+empdata.name+' - '+payslip.month+' '+payslip.year" :emp_etin="empdata.etin" :emp_department="payslip.department" :emp_jobposition="payslip.jobposition" :emp_code="emp_public_info.employee_code" :emp_joining="emp_joinng_date" :emp_branch="payslip.branch_name"></Employeepfslipdetails> -->
  </div>
</template>

<script>


export default {

  mounted() {
    this.$refs.trzcalendar;
  },
  props: ['pageurl', 'flag'],
  components: {},
  data() {

    return {
      company_name: '',
      pageUrl: this.$api_url,
      waiver_key: 0,
      search: '',
      length: 100,
      pagination: {currentPage: 1, pages: 1},

      empty_result: 'Please hold tight! We are preparing the report data for you!',

      fiscal_year: '',

      payroll_reporting_data: [],
      details: [],
      showoverlay: true,
      loader: false,
      /***Ali */

      column_selected: [],
      column_options: [],
      default_fields: [],
      column_selected_view: [],
      show_selected: '',
      /**Child Component property data */
      is_action: 1,
      checkbox: 0,
      list_key: 0,
      custom_list: [],
      default_column: ['name', 'employee_code'],
      appended_column: [
        {value: "pf_start", text: "PF Start Date", type: "date"},
        // {value: "pf_total", text: "Total Balance", type: "number"}, // Rejwan: 23-04-2025 2 decimal
        {value: "pf_total", text: "Total Balance", type: "amount"}, // Rejwan: 23-04-2025 2 decimal
      ],
      primary_key: 'employee_id',
      company_options: [],
      tmp_custom_list: [],
      custom_array: [],
      /***Child Component property data */
      empty_result: 'Fetching Data!',
      curr_emp_pf_total: 0,
      curr_emp_monthly_pf_total: {},
      pfoverlay: true,
      empdata: [],
      m_search_data: [],
      emp_pf_title: '',
      emp_btn_title: '',

      notice: "",
      blankmsg: 'Fetching data..',
      people: 0,
      c_date: '',
      c_time: '',
      pf_type: 0,
      curr_emp_mpf_total: {},
      pf_types: [
        {value: "0", text: "Registered"},
        {value: "1", text: "Unregistered"}
      ],
      action_loader: false,
      report_data: [],
      employee_info: [],
      showWaiverForm: false,
      store_scope: 'front',
      pf_settings: {pf_year_end: {opt_value: 12, status: 0}, pf_profit_waive_feature: {opt_value: 0, status: 0},},
      f_y: [],
      year: '',
      payrunyears: [],
      pay_slip_details: [],
      dynamic_fields: [],


    }
  },
  methods: {
    getPFReportHeaderInfo: function () {
      // axios.get(this.$api_url + '/pfreport/header')
      axios.get(this.$api_url_front + '/pf/report/header')
          .then(function (response) {
            this.company_name = response.data.company_name;
            this.c_date = response.data.curr_date;
            this.c_time = response.data.curr_time;
            this.pf_type = response.data.pf_type;


          }.bind(this));

    },
    showPFSlipModal: function (slip_detail) {

      this.pay_slip_details = slip_detail;
      this.$bvModal.show('bv-modal-pf-slip');
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    replaceTableHeads(val) {
      val = val.replace(/_/g, ' ');

      val = val.toLowerCase().split(' ');
      for (var i = 0; i < val.length; i++) {
        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
      }
      return val.join(' ');
    },

    filterFiscalYear(myear, month) {

      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];

      const monthIndex = monthNames.findIndex(name => name.toLowerCase() === month.toLowerCase());
      var f_start = 0;
      var f_end = 0;
      if (this.pf_settings.pf_year_end.opt_value != 12) {
        var fiscalYearParts = this.year.split('-');
        f_start = parseInt(fiscalYearParts[0]);
        f_end = parseInt(fiscalYearParts[1]);
      } else {
        f_start = parseInt(this.year);
        f_end = parseInt(this.year);
      }
      const fiscalYearStart = parseInt(f_start);
      const fiscalYearEnd = parseInt(f_end);

      // Parse the date string into a Date object

      const dateMonth = monthIndex + 1; // JavaScript Date object uses 0-indexed months
      const dateYear = parseInt(myear);
      const date = new Date(dateYear, dateMonth);


      if (this.pf_settings.pf_year_end.opt_value != 12) {
        var end = parseInt(this.pf_settings.pf_year_end.opt_value);
        var start = 1;
        if (end == 12) {
          start = 1;
        } else {
          start = end + 1;
        }
      } else {
        start = 1;
        end = 12;
      }


      const fiscalYearStartMonth = start; // Fiscal year starts on April 1st
      const fiscalYearStartDate = new Date(fiscalYearStart, fiscalYearStartMonth);
      const fiscalYearEndMonth = end; // Fiscal year ends on March 31st
      const fiscalYearEndDate = new Date(fiscalYearEnd, fiscalYearEndMonth, 31);

      return date >= fiscalYearStartDate && date <= fiscalYearEndDate;
      return 0;
    },
    getPFContributionsData: function () {
      let currentObj = this;
      this.showoverlay = true;
      axios.get(this.$api_url + '/pfreport/contributions', {
        params: {}
      }).then(function (response) {
        this.showoverlay = false;

        /* Assingning the list */

        /* Assingning the Options */

        this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

        /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

        this.custom_list = this.tmp_custom_list;

      }.bind(this)).catch(function (error) {
        currentObj.showoverlay = false;
        currentObj.serverError(error);
        console.log(error)
      });

    },
    getPayslipDynamicFieldData: function (emp_id) {
      let formData = new FormData();

      formData.append('employee_id', emp_id);

      //currentObj.showoverlay = true;

      axios.post(this.$api_url_front + '/company/payslip-field-settings/get-employee-dynamic-field-data', formData)
          .then(function (response) {

            var ltData = response.data;
            this.dynamic_fields = ltData;


          }.bind(this));
    },
    download_file(fileURL) {
      if (!this.checkNet()) return false;

      var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
      if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
        save.download = fileName || filename;
        if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
          document.location = save.href;
        } else {
          var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      } else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
      }
    },

    stringView(str) {
      var i, frags = str.split('_');
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    pfDetailsNew: function () {

      let currentObj = this;

      let formData = new FormData();

      formData.append('viewmode', 1);
      formData.append('d_type', 'excel');
      formData.append('year', this.year);
      formData.append('front', 1);
      formData.append('data_front', 'yes');
      this.pfoverlay = true;
      this.report_data = [];
      this.details = [];
      this.employee_info = [];

      currentObj.showoverlay = true;

      axios.post(this.$api_url + '/front/pf/report/profile', formData)
          .then(function (response) {
            this.report_data = response.data.file_name;
            this.employee_info = response.data.file_name.employee_info;
            this.details = response.data.file_name.data;
            currentObj.showoverlay = false;
            this.getEmployeeActiveYearlist(this.employee_info.employee_id);
            this.getPayslipDynamicFieldData(this.employee_info.employee_id);

            this.pfoverlay = true;
          }.bind(this))
          .catch(function (error) {
            currentObj.showoverlay = false;
            console.log(error);
          });


      this.$bvModal.show('bv-modal-pf-details');

    },
    showInterestWaiverForm: function () {
      this.waiver_key += 1;
      this.showWaiverForm = true;
      this.$bvModal.show('bv-modal-process-waiver');
    },
    getPfMonthlyTotalContribution: function (pf_cont_data) {

      if (pf_cont_data.length > 0) {

        let pf_employer_total = 0.00;
        let pf_employee_total = 0.00;
        let pf_profit_total = 0.00;
        let pf_forfieture_total = 0.00;
        let pf_loan_availed_total = 0.00;
        let pf_loan_refund_total = 0.00;
        let pf_settlement_total = 0.00;

        for (let i = 0; i < pf_cont_data.length; i++) {

          let pf_employer = parseFloat(this.toMoney(pf_cont_data[i].pf_employer));
          let pf_employee = parseFloat(this.toMoney(pf_cont_data[i].pf_employee));
          let pf_profit = parseFloat(this.toMoney(pf_cont_data[i].pf_profit));
          let pf_forfieture = parseFloat(this.toMoney(pf_cont_data[i].pf_forfieture));
          let pf_loan_availed = parseFloat(this.toMoney(pf_cont_data[i].pf_loan_availed));
          let pf_loan_refund = parseFloat(this.toMoney(pf_cont_data[i].pf_loan_refund));
          let pf_settlement = parseFloat(this.toMoney(pf_cont_data[i].pf_settlement));


          pf_employer_total += pf_employer;
          pf_employee_total += pf_employee;
          pf_profit_total += pf_profit;
          pf_forfieture_total += pf_forfieture;
          pf_loan_availed_total += pf_loan_availed;
          pf_loan_refund_total += pf_loan_refund;
          pf_settlement_total += pf_settlement;

        }


        this.curr_emp_monthly_pf_total.pf_employer = pf_employer_total + this.curr_emp_mpf_total.pf_employer;
        this.curr_emp_monthly_pf_total.pf_employee = pf_employee_total + this.curr_emp_mpf_total.pf_employee;
        this.curr_emp_monthly_pf_total.pf_profit = pf_profit_total;
        this.curr_emp_monthly_pf_total.pf_forfieture = pf_forfieture_total;
        this.curr_emp_monthly_pf_total.pf_loan_availed = pf_loan_availed_total;
        this.curr_emp_monthly_pf_total.pf_loan_refund = pf_loan_refund_total;
        this.curr_emp_monthly_pf_total.pf_settlement = pf_settlement_total;

      }

    },
    getMigratedPfTotalContribution: function (mpf_cont_data) {
      let mpf_employer_total = 0.00;
      let mpf_employee_total = 0.00;

      if (mpf_cont_data.length > 0) {


        for (let i = 0; i < mpf_cont_data.length; i++) {

          let mpf_employer = parseFloat(this.toMoney(mpf_cont_data[i].employer_contribution));
          let mpf_employee = parseFloat(this.toMoney(mpf_cont_data[i].employee_contribution));

          mpf_employer_total += mpf_employer;
          mpf_employee_total += mpf_employee;

        }

      }
      this.curr_emp_mpf_total.pf_employer = mpf_employer_total;
      this.curr_emp_mpf_total.pf_employee = mpf_employee_total;


    },

    // Start: Rejwan: 24-04-2025 2 decimal
    // formatMoney: function (amount) {
    //   var money = Number(amount);
    //   var dec_points = 0;

    //   if (this.$atl_company_number_format == 'no') {
    //     money = Math.round(money);
    //     money = money.toLocaleString();
    //   } else {
    //     money = money.toLocaleString();
    //     if (money == 'NaN')
    //       money = amount;
    //     else {
    //       if (money.indexOf(".") < 0) {
    //         money = money + ".00";
    //       } else {
    //         dec_points = money.length - money.indexOf('.') - 1;

    //         if (dec_points == 1) {
    //           money = money + "0";
    //         } else if (dec_points == 0) {
    //           money = money + "00";
    //         }
    //       }

    //     }
    //   }

    //   return money;
    // },
    toMoney: function (amount) {
      if (amount != "0") {
        if (!isNaN(amount)) {
          var number = Number(amount);
          return number;
        }
        var NumWithoutCommas = amount.replace(/,/g, '');
        var number = Number(NumWithoutCommas).toFixed(2);
        return number;
      } else
        return amount;
    },
    getEmployeePfReport: function () {

      var curr_obj = this;

      let formData = new FormData();

      formData.append('d_type', 'excel');
      this.loader = true;
      this.downloadBlobResponse(
          axios.post(this.$api_url + '/front/pf/report/profile', formData, { responseType: 'blob' }),
          'loader' // your loader key in this component
      );


    },
    capitalizeTheFirstLetterOfEachWord(words) {
      var separateWord = words.toLowerCase().split(' ');
      for (var i = 0; i < separateWord.length; i++) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
            separateWord[i].substring(1);
      }
      return separateWord.join(' ');
    },
    waiverReturn() {
      this.pfDetailsNew();
      this.showWaiverForm = false;
      this.$bvModal.hide('bv-modal-process-waiver');
    },
    get_current_fiscal_year: function () {
      //
      if (!this.checkNet()) return false;
      axios.get(this.$api_url_front + '/getcurrentfiscalyear', {}).then(function (response) {
        this.year = response.data;
        this.pfDetailsNew();

      }.bind(this));
    },
    getPFSettings: function () {

      let currentObj = this;
      axios.get(this.$api_url_front + '/pf/settings').then(function (response) {
        currentObj.pf_settings = response.data.data;


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    getEmployeeActiveYearlist: function (employee_id) {

      if (!this.checkNet()) return false;

      let formData = new FormData();

      formData.append('employee_id', employee_id);

      //currentObj.showoverlay = true;

      axios.post(this.$api_url + '/front/pf/employee/active-year-list', formData)
          .then(function (response) {
            this.respData = response.data;

            if (this.respData.fiscal_year.length > 0) {
              this.payrunyears = this.respData.fiscal_year;
              this.f_y = this.respData.year;
              if (this.pf_settings.pf_year_end.opt_value != 12) {
                this.year = this.payrunyears[0];
              } else {
                this.year = this.f_y[0];
              }
            } else {
              this.statememt_available = false;
            }
            this.showoverlay = false;

          }.bind(this)).catch(function (error) {
        alert(error)
      });


    },

  },
  created: function () {

    this.getPFReportHeaderInfo();
    //this.pfDetailsNew();
    this.getPFSettings();
    this.get_current_fiscal_year();
  },
  computed:
      {}
}
</script>
<style>

.title-sub-text {
  font-size: 14px;
  display: block;
  margin-top: 10px;
}

.pf_schedule_title_head_left {
  font-size: 18px;
  /* width: 26%; */
}

.employee_info_schecdule h3 {
  font-size: 15px;
}

.employee_info_schecdule {
  font-size: 15px !important;
}
</style>
